import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';
import {NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective} from 'ng-zorro-antd/input';

@Component({
  selector: 'app-mb-search',
  standalone: true,
  imports: [CommonModule, FormsModule, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective],
  templateUrl: './mb-search.component.html',
  styleUrls: ['./mb-search.component.css'],
})
export class MbSearchComponent {
  @Input() placeholder = 'Search here';
  @Input() prefixLabel = '';
  @Input() searchValue = '';
  @Input() width = '';
  @Input() height = '';

  @Output() searchValueChange = new EventEmitter<string>();
  @Output() searchSubmit = new EventEmitter<string>();
  @Output() clearSearch = new EventEmitter<void>();

  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;

  onSearchValueChange(value: string): void {
    this.searchValue = value;
    this.searchValueChange.emit(value);

    // Automatically reload data when search becomes empty
    if (value === '' || value.trim() === '') {
      this.clearSearch.emit();
    }
  }

  onSearch(): void {
    this.searchSubmit.emit(this.searchValue);
  }

  onClearSearch(): void {
    this.searchValue = '';
    this.searchValueChange.emit('');
    this.clearSearch.emit();
  }

  onKeyDown(event: any): void {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }
}
